import AboutSection from "../../Components/HomeSections/AboutSection";
import AttorneySection from "../../Components/HomeSections/AttorneySection";
import HeroSection from "../../Components/HomeSections/HeroSection";
import TestimonialSlider from "../../Components/HomeSections/Testimonials";
import WhyChooseUs from "../../Components/HomeSections/WhyChooseUs";
import ContactForm from "../../Components/HomeSections/ContactForm";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import ServicesList from "../../Components/Services/ServicesList";
import CallToAction from "../../layout/CTA";
import { Helmet } from "react-helmet-async";

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Leading Law Firm in Delhi NCR | R & P Law Partners</title>

        <meta
          name="description"
          content="R & P Law Partners delivers trusted legal services across Delhi NCR for criminal, civil, corporate, family, cyber, and commercial law matters."
        />

        <meta name="keywords" content="Home" />

        <link rel="canonical" href="https://rplawpartners.com/" />
      </Helmet>

      <Header />
      <HeroSection />
      <AboutSection />
      <ServicesList />
      <WhyChooseUs />
      {/* <AttorneySection/> */}
      <TestimonialSlider />
      <ContactForm />
      <CallToAction />
      <Footer />
    </>
  );
};

export default HomePage;
